import * as React from 'react';
import { SVGProps } from 'react';

const IconSaturationSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.5 4H10v1h.5a.5.5 0 0 0 0-1ZM5.5 12H6v-1h-.5a.5.5 0 0 0 0 1ZM10 11h.5a.5.5 0 0 1 0 1H10v-1ZM5.5 5H6V4h-.5a.5.5 0 0 0 0 1ZM10 6h2.5a.5.5 0 0 1 0 1H10V6ZM3.5 10H6V9H3.5a.5.5 0 0 0 0 1ZM10 9h2.5a.5.5 0 0 1 0 1H10V9ZM3.5 7H6V6H3.5a.5.5 0 0 0 0 1Z"
      fill="var(--color-typo-primary)"
    />
    <rect
      x={7}
      y={2}
      width={2}
      height={12}
      rx={1}
      fill="var(--color-typo-normal)"
    />
  </svg>
);
export default IconSaturationSizeS;
